import BadgerAccordion from 'badger-accordion';

function AccordionInit () {
  const accordions = document.querySelectorAll('.js-badger-accordion');
  Array.from(accordions).forEach((accordion) => {
    const ba = new BadgerAccordion(accordion); // eslint-disable-line no-unused-vars
  });
}

$(function () { setTimeout(AccordionInit, 700); });
